import { useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import CardHeaderCommon from "../../../../../CommonElements/CardHeaderCommon/CardHeaderCommon";
import { ClipboardTextInput, Copy, Cut, CutAndCopyText, CutAndCopyTextPlaceholder } from "../../../../../utils/Constant";

const ClipboardOnTextInput = () => {
  const [clipboardTextValue, setClipboardTextValue] = useState("");

  const handleCopy = async () => {
    await navigator.clipboard.writeText(clipboardTextValue);
    setClipboardTextValue(clipboardTextValue);
  };
  const handleCut = async () => {
    await navigator.clipboard.writeText(clipboardTextValue);
    setClipboardTextValue("");
  };
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon title={ClipboardTextInput} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description">{CutAndCopyText}</P>
            <Input id="clipboardExample1" type="text" placeholder={CutAndCopyTextPlaceholder} value={clipboardTextValue} onChange={({ target: { value } }) => setClipboardTextValue(value)} />
            <div className="mt-3 text-end">
              <Btn color="primary" className="btn-clipboard me-1" onClick={handleCopy}>
                <i className="fa fa-copy"></i> {Copy}
              </Btn>
              <Btn color="secondary" className="btn-clipboard-cut" onClick={handleCut}>
                <i className="fa fa-cut"></i> {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ClipboardOnTextInput;
